import { HubBaseUrl } from '../../../../consts'
import { toast } from 'react-toastify'
import { authorizeAction, AUTHZ_ACTIONS } from '../../../UI/Auth/SamlAuth/Authorization'

export const postDeactivateScript = (scriptKey: number) => {
  if (!authorizeAction({
    [AUTHZ_ACTIONS.SCRIPTING_PERMISSIONS_KEY]: AUTHZ_ACTIONS.SCRIPTING_PERMISSIONS.CAN_ACTIVATE
  })) {
    return
  }

  return fetch(
    `${HubBaseUrl}/scripts/${scriptKey}/deactivate`,
    {
      method: 'POST',
      headers: {
        'X-Kubeshark-Capture': 'ignore',
      },
    },
  )
    .then(response => response.ok ? response : response.text().then(err => Promise.reject(err)))
    .catch(err => {
      if (err.length > 0) {
        console.error(err)
        toast.error(err.toString(), {
          theme: "colored"
        })
      }
    })
}
